import createReducer from 'utils/redux/createReducer'
import { route } from '../selectors/common'

const initialState = {
	'property/facts': false
  , 'project/tasks': true
  , 'transaction/lines': true
}
let single = {
	'properties': 'property',
    'projects': 'project'
}
let plurals = {
	'merchant': 'merchants',
    'project': 'projects'
}
export default createReducer(initialState, {
	SECTION_EXPAND: (currentState, action) => ({
		...currentState
	  , [action.data.section]: action.data.expanded
	})
  , ADD: (currentState, action, megastate) => {
		let section = single[route(megastate)[0]] + '/' + plurals[action.data.type]
		return {
			...currentState
		}
	}
  , COMMENT_ADD: (currentState, action) => ({
		...currentState
	  , 'comments': true
	})
  , LINE_ADD: (currentState, action) => ({
  	...currentState
    , 'transaction/lines': true
  })
  , ATTACHMENTS_ADD: (currentState, action) => ({
		...currentState
	  , 'attachments': true
	})
})



// WEBPACK FOOTER //
// ./src/reducers/sections.js